import { MarkdownViewer } from '@/components/TenantSettings/MarkdownViewer.tsx';
import { FC } from 'react';

interface MarkdownProps {
  markdownText: string;
}

const MarkdownContent: FC<MarkdownProps> = ({ markdownText }) => {
  return (
    <div className="flex w-full min-w-0 max-w-panel-full flex-col rounded-md border border-background-300 p-4 sm:p-8">
      <MarkdownViewer markdown={markdownText} />
    </div>
  );
};

export default MarkdownContent;
